module.exports = __webpack_public_path__ + "media/images/pic/godzilla-mobile-dce4434977d253abfb19c7255135cb94.png";